<template>
  <div class="common-layout">
    <el-container style="min-height: 100vh">
      <el-header style="padding: 0">
        <el-affix :offset="0">
          <HeaderModule />
        </el-affix>
      </el-header>
      <el-main style="padding: 0; margin-top: -60px; background-color: rgba(245, 247, 250, 0.5)">
        <div class="theme">
          <el-text tag="b" class="theme-text theme-title">更新日志</el-text><br/>
          <el-text tag="b" class="theme-text theme-body">明日复明日，明日何其多。 ——钱福</el-text>
        </div>
        <el-timeline
          style="max-width: 40%; margin: 20px auto 0 auto; font-size: 30px"
        >
          <el-timeline-item
            v-for="(item, index) in updateLogInfo"
            :key="index"
            :timestamp="item.timestamp"
            placement="top"
            :type="types[index % types.length]"
            
          >
          <el-space direction="vertical" :fill-ratio=fillRatio style="width: 100%" fill wrap :size="size">
            <el-card v-for="(info,index) in item.info" :key="index" class="box-card">
              <h4>{{ info.title }}</h4>
              <p>{{ info.content }}</p>
            </el-card>
          </el-space>
          </el-timeline-item>
        </el-timeline>
      </el-main>
      <el-footer>
        <FooterModule />
      </el-footer>
    </el-container>
  </div>
  <BackTop />
  <BackGround style="position: absolute; z-index: -1;" />
</template>
  
<script>
import { ref } from "vue";
export default {
  components: {},
  setup() {
    const fillRatio = ref(100)
    const size = ref(15)
    const types = [ "success", "warning", "danger","primary"];
    const updateLogInfo = ref([
      { timestamp: "2018/4/3", info:[{content: "Item 1 content", title: "测试数据1"},{content: "Item 1.1 content", title: "测试数据1.1"}] },
      { timestamp: "2018/4/4", info:[{content: "Item 2 content", title: "测试数据2"}] },
      { timestamp: "2018/4/5", info:[{content: "Item 3 content", title: "测试数据3"}] },
      
    ]);
    updateLogInfo.value.forEach((item) => {
      item.type = types[Math.floor(Math.random() * types.length)];
      item.hollow = true; // 或者根据需要设置为 false
    });
    return {
      updateLogInfo,
      types,
      size,
      fillRatio
    };
  },
};
</script>
  
  <style scoped>
:deep(.is-top) {
  color: #000000;
  font-size: 30px;
}
.el-carousel__item h3 {
  display: flex;
  color: #475669;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.full-carousel {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.el-carousel__container,
.el-carousel__item {
  height: 100%;
}
.el-timeline-item__timestamp {
  font-size: 30px;
  text-align: left;
  color: #000;
}
.el-timeline-item__tail{
    left: 7px;
}
.el-timeline-item__node{
    height: 20px;
    width: 20px;
}

.theme {
  height: 50vh;
  width: 100%;
  background-image: url("../../assets/img/29dcc02e833def4808ddaded64b4e40.jpg"); /* 确保路径正确 */
  background-size: cover; /* 图片将尽可能大地覆盖整个容器，可能会被裁剪 */  
  background-position: center; /* 图片居中显示 */  
  background-repeat: no-repeat; /* 不重复 */  
  display: flex; /* 启用Flexbox布局 */
  justify-content: center; /* 水平居中 */  
  align-items: center; /* 垂直居中 */  
  flex-direction: column; /* 如果需要子元素垂直排列（在这个例子中不是必需的，但可以用于其他布局）*/  
}
.theme h1 {  
  margin: 0; /* 可能需要移除默认的margin来确保更精确的居中 */  
}
@font-face {
  font-family: "MyCustomFont";
  src: url("../../assets/font/luzhongmocaishou.ttf") format("opentype");
}
.theme-text{
  font-family: "MyCustomFont", sans-serif;
  color: #FFFFFF;
  letter-spacing: 4px;
}
.theme-title{
  font-size: 40px;
}
.theme-body{
  font-size: 20px;
}
</style>